import { Badge, Tooltip } from '@mui/material'
import PublicIcon from '@mui/icons-material/Public'
import AddIcon from '@mui/icons-material/Add'

const DiscoveryPlusIcon = ({ handleClick }: { handleClick?: any }) => {
  return (
    <Tooltip title='Add New Discovery'>
      <Badge badgeContent={<AddIcon sx={{ fontSize: '18px' }} />} color='default'>
        <PublicIcon sx={{ fontSize: '30px', color: 'rgb(25, 117, 255)' }} />
      </Badge>
    </Tooltip>
  )
}

export default DiscoveryPlusIcon
